import type { ServerOfferStatus } from '@yoop/server-model/token-info';
import { offerPredicate } from '@yoop/util-offer-group/predicate';
import { requested } from '../predicate/requested';
import { requestedAndNotLost } from '../predicate/requested-and-not-lost';

/**
 * Checks if a group of offers contains at least one unsecured offer
 * @param offerGroups
 */
export const containsUnsecuredOffer: (
  offerGroups: { activeOffer?: { offerStatus?: ServerOfferStatus } }[],
  notLost: boolean,
) => boolean = (
  offerGroups: { activeOffer?: { offerStatus?: ServerOfferStatus } }[],
  notLost: boolean,
) => offerGroups.some(offerPredicate(notLost ? requestedAndNotLost : requested));
